













import Vue from 'vue';
import { Status, IState } from '../store/state';

interface IStatusMessageComputed {
	statusClass: any;
	statusMessage: string;
	status: Status;
}

interface IStatusMessageData {
	show: boolean;
}

interface IStatusMessageMethods {
	close(): void;
}

export default Vue.extend<IStatusMessageData, IStatusMessageMethods, IStatusMessageComputed, {}>({
	name: 'StatusMessage',
	data(){
		return {
			show: false
		}
	},
	created() {
		this.$nextTick(() => {
			if(this.status !== 0) {
				this.show = true;
			}
		})
	},
	watch: {
		status(newStatus, oldStatus) {
			this.show = true;
		}
	},
	methods: {
		close(){
			this.show = false;
		}
	},
	computed: {
		status(){
			return (this.$store.state as IState).status.code;
		},
		statusMessage(){
			return (this.$store.state as IState).status.messages[this.status]
		},
		statusClass(){
			switch(this.status) {
				case Status.NOT_OK:
					return {
						'sh-message--error': true
					}
				default:
					return {
						'sh-message--success': true
					}
			}
		}
	}
})
